import { jsx as e } from "react/jsx-runtime";
import { d as s, af as l } from "../../vendor-CPVnY93G.js";
import { Avatar as r } from "../Avatar/index.js";
import { BaseIcon as i } from "../BaseIcon/index.js";
import { Icon as a } from "../Icon/index.js";
import { Hotkey as m } from "../Hotkey/index.js";
import { Pill as d } from "../Pill/index.js";
import '../../assets/index32.css';const f = "_item_127fz_1", _ = "_generated_127fz_36", b = "_selectable_127fz_45", p = "_decorationLeft_127fz_54", g = "_decorationRight_127fz_63", u = "_label_127fz_71", h = "_description_127fz_80", c = {
  item: f,
  generated: _,
  selectable: b,
  decorationLeft: p,
  decorationRight: g,
  label: u,
  description: h
};
function z({ as: t, className: n, ...o }) {
  return /* @__PURE__ */ e(t, { ...o, className: s(c.item, n) });
}
const R = ({ avatarProps: t, iconProps: n }) => {
  let o = null;
  return t ? o = /* @__PURE__ */ e(r, { ...t }) : n && (o = /* @__PURE__ */ e(a, { ...n, color: n.color ?? "moon" })), /* @__PURE__ */ e("div", { className: c.decorationLeft, children: o });
}, N = ({ hotkeyProps: t, pillProps: n }) => {
  let o = null;
  return t ? o = /* @__PURE__ */ e(m, { ...t }) : n && (o = /* @__PURE__ */ e(d, { ...n })), /* @__PURE__ */ e("div", { className: c.decorationRight, children: o });
}, L = ({ children: t }) => /* @__PURE__ */ e(l, { elementType: "span", slot: "label", className: c.label, children: t }), v = ({ children: t }) => t ? /* @__PURE__ */ e(l, { elementType: "span", slot: "description", className: c.description, children: t }) : null, E = Object.assign(z, {
  DecorationLeft: R,
  DecorationRight: N,
  Label: L,
  Description: v,
  Selectable: () => /* @__PURE__ */ e("div", { className: s(c.generated, c.selectable), children: /* @__PURE__ */ e(i, { icon: "checkmark2", color: "moon", size: "sm" }) }),
  Submenu: () => /* @__PURE__ */ e("div", { className: c.generated, children: /* @__PURE__ */ e(i, { icon: "chevron-next", color: "moon", size: "sm" }) })
});
export {
  R as DecorationLeft,
  N as DecorationRight,
  v as Description,
  E as ItemRow,
  L as Label
};
